import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import scheduleMods from "data/schedule-mods";
import PrivateRoute from "components/common/PrivateRoute";
import SchedulingMap from "components/menu/scheduling/map";

const SchedulingMapRouter = props => (
    <div className="px-5">
        <Switch>
            <Route
                exact
                path={`${props.match.url}`}
                component={() => <Redirect to={`${props.match.url}/${scheduleMods.NotActivated.value}`} />}
            />

            <PrivateRoute
                exact
                path={`${props.match.url}/:mode`}
                component={SchedulingMap}
                match={props.match}
            />
        </Switch>
    </div>
);

export default SchedulingMapRouter;
